module.exports = __webpack_public_path__ + "img/bg-header.1e6bf9af.png";